import { gql } from "@apollo/client";

export const REMITTANCE_ITEM_FRAGMENT = gql`
  fragment RemittanceItemFields on RemittanceItemType {
    purchaser {
        purchaserId
        purchaserName
        purchaserKey
    }
    checkNo
    deductionCount
    grossAmount
    netAmount
    discountAmount
    invoiceNo
    description
    invoiceDate
    age
    isDeduction
    remittanceId
    remittanceItemId
    priority {
        priorityId
        priorityName
        priorityKey
    }
    validity {
        validityId
        validityName
        validityKey
    }
    stage {
        stageId
        stageName
        stageKey
        isCurrent
    }
    status {
        statusId
        statusName
        statusKey
        isCurrent
    }
    adjustmentType {
        id
        typeName
        typeKey
    }
    adjustmentCategory {
        id
        categoryName
        categoryKey
    }
    analystUser {
        userId
        fullName
        avatar
        isDeleted
    }
    approverUser {
        userId
        fullName
        avatar
        isDeleted
    }
    isIncompleteDeduction
    isManuallyUploaded
    isBackupRequested
    canRequestBackup
    isDisputed
    deductionDispute {
        disputeRequest {
            id
            raisedAt
            raisedBy {
                userId
                fullName
                avatar
                isDeleted
            }
            notes
        }
        disputeResponse {
            id
            responseAt
            responseBy {
                userId
                fullName
                avatar
                isDeleted
            }
            responseNotes
        }
    }
    returned {
        returnedBy {
            userId
            fullName
            avatar
            isDeleted
        }
        returnedAt
        returnedMessage
    }
  }
`;